import './loadjQuery.js';
import $ from 'jquery';
import '@popperjs/core';
import * as bootstrap from 'bootstrap';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

//import 'bootstrap/dist/css/bootstrap.css';
// Custom JS imports
import './vendor/jquery.lbt-lightbox.js';
import './map.js';
import * as Utility from './utility.js';
import * as Helper from './helper.js';
import './search.js';

// Custom CSS imports
import '../scss/custom.scss';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/vendor/jquery.lbt-lightbox.css';

import 'overlayscrollbars/overlayscrollbars.css';
import {
    OverlayScrollbars,
    ScrollbarsHidingPlugin,
    SizeObserverPlugin,
    ClickScrollPlugin,
} from 'overlayscrollbars';

import '../css/site.css';

// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.
let VALID_LOGO_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
let LIGHTBOX_GALLERY_INSTANCES = {};
document.addEventListener('DOMContentLoaded', function () {
    const ENDPOINT_METADATA_API_RETRIEVE = '/api/metadata/retrieve';
    const HEADER_BANNER_COOKIE_IN_ACTIVE_VALUE = 'NOT_ACTIVE';
    console.log('[DOMContentLoaded]');
    initializeLightBoxGallery();
    initializeHomePageCitySelectorCookie();
    bindOpenNewTabElements();
    initializeScrollableRecentHomes();
    bindContactSalesClickOnPropertyViewPage();
    bindScrollEventOnAdvertisement();
    bindCategoryBadgeOnBlogListPage();
    loadHeaderBanner();
    function initializeLightBoxGallery() {
        $('.light-box-gallery-container').each(function (index, element) {
            let galleryId = element.id;
            LIGHTBOX_GALLERY_INSTANCES[galleryId] = $('#' + galleryId).lbtLightBox({
                qtd_pagination: 4,
                pagination_width: '120px',
                pagination_height: '120px',
                custom_children: '.box img',
                captions: true,
                captions_selector: '.caption p',
            });
        });
    }

    function initializeHomePageCitySelectorCookie() {
        $('.home-page-city-selector').on('change', function (e) {
            if ($(this).val()) {
                let selectedCity = $(this).val();
                if (selectedCity) {
                    let cookieName = $(this).attr('data-ckname');
                    if (cookieName !== undefined) {
                        Helper.setCookie(cookieName, selectedCity, 7);
                    }
                    window.location.href = Utility.getAbsolutePath('/newhomes/' + selectedCity);
                }
            } else {
                let cookieName = $(this).attr('data-ckname');
                if (cookieName !== undefined) {
                    Helper.clearCookie(cookieName);
                }
            }
        });
        $('.home-page-city-go').on('click', function (e) {
            let selectedCity = $('.home-page-city-selector').val();
            if (selectedCity) {
                window.location.href = Utility.getAbsolutePath('/newhomes/' + selectedCity);
            } else {
                window.location.href = Utility.getAbsolutePath('/newhomes/calgary--ab');
            }
        });
    }

    function bindContactSalesClickOnPropertyViewPage() {
        $('#btncontactsales').on('click', function (e) {
            //Serialize the form datas.
            console.log(e);
            let dataAttributes = e.currentTarget.dataset;
            let actionRoute = dataAttributes['actionRoute'];
            let redirectOnSuccess = dataAttributes['redirectOnSuccess'];
            let callbackOnSuccess = dataAttributes['callbackOnSuccess'];
            let callbackOnSuccessArguments = dataAttributes['callbackOnSuccessArguments'];
            let formId = dataAttributes['formId'];
            if (actionRoute && actionRoute !== undefined) {
                let formIdSelector =
                    formId !== undefined && formId !== '' ? '#' + formId : '#mainform';
                let isValid = Utility.isFormValid(formIdSelector);
                var formdata = new FormData($(formIdSelector).get(0));
                console.log('[formdata]' + formdata);
                for (const pair of formdata.entries()) {
                    console.log(`${pair[0]}, ${pair[1]}`);
                }
                if (!isValid) {
                    return;
                }
                $.ajax({
                    url: actionRoute,
                    type: 'POST',
                    data: formdata,
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    success: function (result) {
                        console.log('[success]');
                        console.log(result);
                        if (
                            redirectOnSuccess &&
                            result &&
                            result.id !== undefined &&
                            result.id !== ''
                        ) {
                            window.location.href = Utility.getSafeRouteByResolvingIdField(
                                redirectOnSuccess,
                                result.id
                            );
                        } else if (callbackOnSuccess && callbackOnSuccess !== '') {
                            callbackHandler(callbackOnSuccess, callbackOnSuccessArguments, result);
                        } else {
                            Utility.showConfirmationModal(
                                'Success',
                                'Your data is saved successfully.'
                            );
                        }
                    },
                    error: function (jqXHR) {
                        console.log(jqXHR);
                        console.log('failure');
                        Utility.showConfirmationModal('Error', 'Something went wrong.');
                    },
                });
            }
        });
    }

    function callbackHandler(functionName, functionArguments, response) {
        switch (functionName) {
            case 'handleRequestInfoResponse':
                handleRequestInfoResponse(response);
                break;
            default:
                console.log('No callback function.');
        }
    }

    function handleRequestInfoResponse(response) {
        if (response && response.success === true) {
            $('#contactSalesResponseMessage').html(response.message);
            $('#contactsalesform').hide();
        } else if (response && response.success === false) {
            $('#contactSalesResponseMessage').html(
                'Something went wrong. Please contact support team.'
            );
        }
    }

    function initializeScrollableRecentHomes() {
        let recentHomeItems = document.querySelectorAll(
            '#carouselRecentlyAddedNewHomes .carousel-item'
        );

        recentHomeItems.forEach((el) => {
            const minPerSlide = 4;
            let next = el.nextElementSibling;
            for (var i = 1; i < minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = recentHomeItems[0];
                }
                let cloneChild = next.cloneNode(true);
                el.appendChild(cloneChild.children[0]);
                next = next.nextElementSibling;
            }
        });
    }
    function bindOpenNewTabElements() {
        $('.target-click-to-tab').on('click', function (e) {
            console.log(e);
            let url = e.currentTarget.dataset.link;
            let adid = e.currentTarget.dataset.ad;
            let adownerid = e.currentTarget.dataset.adowner;
            if (adid && adownerid && adid.length > 0) {
                let data = { adid, adownerid };
                const cevent = new CustomEvent('adclick', { detail: data });
                document.dispatchEvent(cevent);
            }
            if (url && url.length > 0) {
                window.open(url, '_blank', 'noopener,noreferrer');
            }
        });
    }
    function initializeScrollableOnSearchPage() {
        if (!Utility.isMobileDevice()) {
            let scrollableDiv = document.querySelector('.search-result-container--listview');
            if (scrollableDiv) {
                console.log('Scrollable div:');
                console.log(scrollableDiv);
                // simple initialization with an element
                const osInstance = OverlayScrollbars(
                    document.querySelector('.search-result-container--listview'),
                    {}
                );
            }
        }
    }

    function bindScrollEventOnAdvertisement() {
        let element = document.getElementById('searchResultContainerList');
        if (element) {
            console.log('[bindScrollEventOnAdvertisement] if');
            element.addEventListener('scroll', initializeAdImpression);
        } else {
            console.log('[bindScrollEventOnAdvertisement] else');
        }
    }

    function initializeAdImpression() {
        let element = document.getElementById('nhnAdvertisementPlaceholder');
        if (element) {
            let isVisibleinview = isInViewport(element);
            if (isVisibleinview && isVisibleinview == true) {
                let adElement = document.getElementById('nhnAdvertisementPlaceholder');
                if (!Utility.isImpressionTracked(adElement)) {
                    Utility.setImpressionTracked(adElement);
                    let adid = adElement.dataset.ad;
                    let adownerid = adElement.dataset.adowner;
                    if (adid && adownerid && adid.length > 0) {
                        console.log('[initializeAdImpression] setImpressionTracked event' + adid);
                        let data = { adid, adownerid };
                        const cevent = new CustomEvent('adimpression', { detail: data });
                        document.dispatchEvent(cevent);
                    }
                }
            }
        }
    }

    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }
    function bindCategoryBadgeOnBlogListPage() {
        $('.nhn-category-badge').each(function (index, element) {
            $(element).on('click', function (event) {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected');
                } else {
                    $(this).addClass('selected');
                }
                processCategoryChange();
            });
        });
        $('.nhn-category-page-navigation').each(function (index, element) {
            $(element).on('click', function (event) {
                event.preventDefault();
                processBlogPageNavigationChange(this);
            });
        });
    }
    function getAllSelectedCategorySlugList() {
        let categoryList = [];
        $('.nhn-category-badge').each(function (index, element) {
            if ($(this).hasClass('selected')) {
                if (element.dataset && element.dataset.slug) {
                    categoryList.push(element.dataset.slug);
                }
            }
        });
        return categoryList;
    }
    function processCategoryChange() {
        let categoryList = getAllSelectedCategorySlugList();
        if (categoryList && categoryList.length > 0) {
            let categories = categoryList.join(',');
            window.location.href = Utility.getAbsolutePath('/blog/?categories=' + categories);
        } else {
            window.location.href = Utility.getAbsolutePath('/blog/');
        }
    }
    function processBlogPageNavigationChange(currentElement) {
        let dataset = currentElement.dataset;
        console.log(dataset);
        let params = new URL(document.location).searchParams;
        let categories = params.get('categories');
        let searchParams = [];
        if (categories && categories != null) {
            searchParams.push('categories=' + categories);
        }
        if (dataset) {
            if (dataset.pageNumber && parseInt(dataset.pageNumber) > 0) {
                searchParams.push('page=' + parseInt(dataset.pageNumber));
            }
        }
        if (searchParams && searchParams.length > 0) {
            window.location.href = Utility.getAbsolutePath('/blog/?' + searchParams.join('&'));
        } else {
            window.location.href = Utility.getAbsolutePath('/blog');
        }
    }

    function loadHeaderBanner() {
        let message = getHeaderBannerFromCookie();
        if (message && message != '') {
            populateHeaderBannerNotification(message);
            console.log('[loadHeaderBanner] [fromcookie]' + message);
        } else {
            fetch(ENDPOINT_METADATA_API_RETRIEVE + '/Header Announcement Banner') // Call the fetch function passing the url of the API as a parameter
                .then((res) => res.json())
                .then(function (res) {
                    console.log('[loadHeaderBanner][fetch]');
                    console.log(res);
                    if (res.success && res.success == true) {
                        if (res.content != null) {
                            setHeaderBannerCookie(res.content);
                        } else {
                            setHeaderBannerCookie(HEADER_BANNER_COOKIE_IN_ACTIVE_VALUE);
                        }
                        populateHeaderBannerNotification(res.content);
                    } else {
                        console.log('[loadHeaderBanner] [fetch] error');
                    }
                })
                .catch(function (err) {
                    console.log('[loadHeaderBanner] [CATCH] error');
                    console.log(err);
                });
        }
    }

    function populateHeaderBannerNotification(message) {
        if (message && message != '' && message != HEADER_BANNER_COOKIE_IN_ACTIVE_VALUE) {
            $('.nhn-top-notification-bar').html(message);
        }
    }

    function getHeaderBannerFromCookie() {
        let notificationMessage = Helper.getCookie('NHN_HEADER_NOTIFICATION');
        if (notificationMessage && notificationMessage !== '') {
            return notificationMessage;
        }
        return '';
    }
    function setHeaderBannerCookie(notificationMessage) {
        Helper.setCookie('NHN_HEADER_NOTIFICATION', notificationMessage, 1);
    }
});
